import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const cardCss = ":host{display:block;width:100%}.card{color:var(--hmc-color-content-default, var(--hmc-color-gray-black, #101820));font-family:var(--font-family-body, \"Inter\", sans-serif);font-size:var(--font-size-medium, 16px);line-height:24px;display:flex;flex-direction:column;width:100%;height:var(--hmc-card-height, auto);box-sizing:border-box;background-color:var(--hmc-color-layout-container, var(--hmc-color-gray-white, #fff));border-radius:var(--hmc-card-border-radius, 8px);border:var(--hmc-card-border-width, 1px) solid var(--hmc-color-layout-divider-default, var(--hmc-color-gray-300, #b7bbc3))}.card.high-density .card-content{padding:var(--hmc-card-content-padding, 16px);font-size:14px;line-height:20px}.card.high-density .p-x{padding:0 16px}.card.high-density .card-footer-container{padding:16px 0}.card.high-density .card-header-container{padding-top:6px}.card-content{flex:1;padding:var(--hmc-card-content-padding, 20px)}.card-header-right{display:flex;align-items:center;gap:8px;justify-content:flex-end;flex-direction:row}.card-header-container{box-sizing:border-box;display:flex;align-items:flex-start;justify-content:space-between;padding-top:12px;border-bottom:1px solid var(--hmc-color-layout-divider-default, var(--hmc-color-gray-300, #b7bbc3))}.card-footer-container{padding:20px 0px;border-top:solid 1px var(--hmc-color-layout-divider-default, var(--hmc-color-gray-300, #b7bbc3))}.p-x{padding:0 20px}";

const HmcCard$1 = /*@__PURE__*/ proxyCustomElement(class HmcCard extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.density = 'medium';
    this.hasHeader = true;
    this.hasFooter = false;
  }
  componentWillLoad() {
    this.hasHeader = Boolean(this.el.querySelector('[slot="card-header"]'));
    this.hasFooter = Boolean(this.el.querySelector('[slot="card-footer"]'));
  }
  renderHeader() {
    const rootClass = {
      'card-header-container': true,
      'high-density': this.density === 'high',
    };
    return (h("div", { class: "p-x" }, h("div", { class: rootClass }, h("slot", { name: "card-header" }), h("div", { class: "card-header-right" }, h("slot", { name: "card-header-actions" })))));
  }
  renderFooter() {
    return (h("div", { class: "p-x" }, h("div", { class: "card-footer-container" }, h("slot", { name: "card-footer" }))));
  }
  render() {
    const { density, hasHeader, hasFooter } = this;
    const rootClass = {
      'card': true,
      'high-density': density === 'high',
    };
    return (h(Host, null, h("div", { class: rootClass }, hasHeader && this.renderHeader(), h("div", { class: "card-content" }, h("slot", null)), hasFooter && this.renderFooter())));
  }
  get el() { return this; }
  static get style() { return cardCss; }
}, [1, "hmc-card", {
    "density": [1],
    "hasHeader": [32],
    "hasFooter": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["hmc-card"];
  components.forEach(tagName => { switch (tagName) {
    case "hmc-card":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, HmcCard$1);
      }
      break;
  } });
}

const HmcCard = HmcCard$1;
const defineCustomElement = defineCustomElement$1;

export { HmcCard, defineCustomElement };
